<header class="maia-step-header" data-testid="maia-step-header">

    <div class="header-left">
        <button type="button"
                class="exit-button"
                data-testid="maia-exit-button"
                (click)="exitRequested.emit()">
            Exit
        </button>
        <!-- Moved here from the chat panel, which is hidden for now. Same
             testid as it had there: only one of the two ever renders. -->
        <button type="button"
                class="upload-button"
                data-testid="maia-upload-new-sov-button"
                (click)="uploadRequested.emit()">
            Upload New File
        </button>
    </div>

    <ol class="step-flow" data-testid="maia-step-flow">
        <li *ngFor="let step of steps; let last = last; let i = index"
            class="step-flow-item"
            [class.step-flow-item-done]="isDone(step.id)"
            [class.step-flow-item-active]="isActive(step.id)"
            [attr.data-testid]="'maia-step-flow-item-' + step.id">

            <span class="step-flow-marker">
                <svg *ngIf="isDone(step.id)" width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="m5 13 5 5 9-11" stroke="currentColor" stroke-width="2.4"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span *ngIf="!isDone(step.id)">{{ i + 1 }}</span>
            </span>

            <span class="step-flow-label">{{ step.label }}</span>

            <span *ngIf="!last" class="step-flow-arrow" aria-hidden="true">→</span>
        </li>
    </ol>

</header>
